<template>
  <button
    type="button"
    aria-haspopup="dialog"
    @click="$CC.showPreferences()"
    aria-label="Open cookie preferences dialog"
    class="rounded-full inline-block max-w-fit items-center bg-primary text-white p-2.5 fixed bottom-0 m-4 right-0 z-20 hover:-rotate-90 transition-all duration-300 cursor-pointer">

    <UiIcon 
      name="Cookie" 
      class="size-6" 
    />

  </button>
</template>

<script setup>
import UiIcon from '@/components/common/UiIcon.vue'
</script>
